module.exports = __webpack_public_path__ + "img/consultantbg02.e6f245a9.jpg";